// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-role-based-access-control.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-role-based-access-control',
  title: 'Implement role-based access control (RBAC) for all system access',
  description:
    "The organisation must implement role-based access control to manage employees' access to systems. RBAC must align access rights with job functions, enforce least privilege, and be reviewed regularly to ensure continued alignment with business needs. Access granted must correspond to the information classification of the resources accessed.",
  category: 'access',
  scfIds: ['SCF-IAM-005', 'SCF-IAM-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'RBAC model and role definitions are documented' },
    { type: 'document-within-sla', description: 'Role review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
